import { CONSTANTS } from 'app/core/constants';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ColeccionistasService } from '../coleccionistas.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AddColeccionistaModel, Coleccion, Departamento, TipoRepresentacion, Titular } from '../models/add-coleccionista.model';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BehaviorSubject, map, Observable, of, switchMap } from 'rxjs';
import { MatRadioModule } from '@angular/material/radio';
import { environment as env } from 'environments/environments';
import { UtilsService } from 'app/modules/utils-service';

@Component({
    selector: 'form-coleccionista',
    templateUrl: 'form-coleccionista.component.html',
    imports:[
        CommonModule, 
        MatFormFieldModule,
        MatInputModule, 
        MatIconModule, 
        MatButtonModule, 
        FormsModule,
        MatSelectModule,
        MatRadioModule,        
        MatAutocompleteModule
    ]
})

export class FormColeccionistaComponent implements OnInit {
    tipologia_id_tipoRepresentacion:number= env.TIPOLOGIA_ID_TIPO_REPRESENTACION
    tipologia_id_departamentos:number = env.TIPOLOGIA_ID_DEPARTAMENTOS
    tipologia_id_titular:number= env.TIPOLOGIA_ID_TITULAR
    tipologia_id_colecciones:number= env.TIPOLOGIA_ID_COLECCIONES
    seccion_prehisapanica:number = env.TIPOLOGIA_ID_SECCION_PREHISPANICA
    seccion_bienes_inmuebles:number= env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES
    seccion_hispanica_republican:number = env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA
    coleccionista:AddColeccionistaModel= new AddColeccionistaModel
    titular:Titular[]=[]
    tipoColeccion:Coleccion[]=[]
    coleccion:Coleccion[]=[]
    tipoRepresentacion:TipoRepresentacion[]=[]
    bienes_inmuebles:number= CONSTANTS.TIPOLOGIA_ID_COLECCION_BIENES_INMUEBLES

    filteredOptions$:Observable<Tipologia[]>
    filter$ = new BehaviorSubject<string>('');
    departamentos:Departamento[]=[]
    
    filterMunicipios$ = new BehaviorSubject<string>('');
    municipios$: Observable<Tipologia[]>;
    municipios:Tipologia[]=[]

    isPrehispanica:boolean = false
   // ID_BLOQUEADO:number = 160853
    tipologyIdPreHispanica:number = CONSTANTS.TIPOLOGIA_ID_COLECCION_PREHISPANICA

    constructor(  
        private coleccionistasService:ColeccionistasService,
        public dialogRef: MatDialogRef<FormColeccionistaComponent>,
        private utilsService:UtilsService,
        @Inject(MAT_DIALOG_DATA) public data:string
    ) {
            this.getDepartamento()
            this.getTitular()
            this.getTipoColeccion()
            this.getTipoRepresentacion()
        }

   ngOnInit() {
        this.filteredOptions$ = this.filter$.pipe(
            switchMap(query => {
            const filtered = this.departamentos.filter(d =>
                d.descripcion.toLowerCase().includes(query.toLowerCase())
            );
            return of(filtered);
            })
        );

        this.municipios$ =this.filterMunicipios$.pipe(
            switchMap(query =>{
                const filtered = this.municipios.filter(m=>
                    m.descripcion.toLowerCase().includes(query.toLowerCase())
                )
                return of(filtered)
            })
        )
    }

    displayFn(departamento: Departamento): string {
        return departamento ? departamento.descripcion : '';
    }

    crearUsuario(){
        this.coleccionistasService.postColeccionistas(this.coleccionista)
            .then((response)=>{
                this.utilsService.openSuccessSnakBar('Coleccionista registrado correctamente.')
                this.dialogRef.close(true);
            })
    }

    getTipoRepresentacion(){
        this.coleccionistasService.getTipologias(this.tipologia_id_tipoRepresentacion)
                .then((response:TipologiasInterface[])=>{
                    this.tipoRepresentacion= response
                }) 
    }

    getTitular(){
        this.coleccionistasService.getTipologias(this.tipologia_id_titular)
                .then((response:TipologiasInterface[])=>{
                    this.titular= response
                    this.coleccionista.titular= this.titular[0]
                }) 
    }

    getDepartamento(){
        this.coleccionistasService.getTipologias(this.tipologia_id_departamentos)
                .then((response:Departamento[])=>{
                    this.departamentos= response
                    this.filter$.next('');
                }) 
    }

    getTipoColeccion(){
        this.coleccionistasService.getTipologias(this.tipologia_id_colecciones)
                .then((response:TipologiasInterface[])=>{
                    this.tipoColeccion= response

                    const secciones = ['prehispánica', 'inmuebles', 'hispánica y republicana'];

                    const seccion = secciones.find(clave =>
                    (this.data || '').toLowerCase().includes(clave)
                    
                    );

                    // Asigna la sección según coincidencias 
                    // de texto entre la descripción recibida y los tipos de colección
                    if (seccion) {
                    this.coleccionista.seccion = this.tipoColeccion.find(
                        (t: Coleccion) => t.descripcion.toLowerCase().includes(seccion)
                        ) as TipologiasInterface;
                        this.getColeccion(this.coleccionista.seccion.tipologiaId)
                    }

                }) 
    }

    getColeccion(seccion:number){
        this.coleccionistasService.getTipologias(seccion)
                .then((response:TipologiasInterface[])=>{
                    this.coleccion= response
                    this.coleccionista.coleccion= this.coleccion[0]
                }) 
    }

    getMunicipios(event:any){
        this.coleccionistasService.getTipologias(event.tipologiaId)
        .then((response:Tipologia[])=>{
            this.municipios= response
            this.filterMunicipios$.next('');
        }) 
    }

    displayFnMunicipio(municipio: Tipologia): string {
        return municipio ? municipio.descripcion : '';
    }

    tipoSeccion(seccion:any){
        if(seccion.tipologiaId === this.tipologyIdPreHispanica){
            this.isPrehispanica = true
            this.coleccionista.titular= this.titular[1]
        }else {
            this.isPrehispanica = false
        }
    }

}